module.exports = __webpack_public_path__ + "img/Banner_Coupon.2d7dc960.png";